
import { Options, Vue } from "vue-class-component";
import { useStore }     from "vuex";
import { key }          from "@/store";

@Options( {} )
export default class CalculModal extends Vue
{
  store  = useStore( key );
  size   = 0;
  amount = 12;

  mounted()
  {
    this.size   = 0;
    this.amount = 12;
  }
}
